import { createSlice } from "@reduxjs/toolkit";

export interface globalDialogProps {
    open: boolean;
    title: string;
    body: JSX.Element | string;
    hidingAction?: boolean;
}

export interface content {
    id: string;
    name: string;
}
interface uiState {
    backdropLoading: boolean;
    drawerOpen: boolean;
    isLoading: boolean;
    importedBreadCrumb: { [key: string]: string };
    globalDialog: globalDialogProps;
    activeSection: string;
    contents?: content[];
}

const initialState: uiState = {
    backdropLoading: false,
    drawerOpen: false,
    isLoading: true,
    importedBreadCrumb: {},
    globalDialog: {
        open: false,
        title: "Info",
        body: "This is a global Dialog for this app."
    },
    activeSection: "",
    contents: []
};

const slice = createSlice({
    name: "ui",
    initialState,
    reducers: {
        openDrawer: (state) => {
            state.drawerOpen = true;
        },
        closeDrawer: (state) => {
            state.drawerOpen = false;
        },
        setPageLoading: (state, actions) => {
            state.isLoading = actions.payload;
        },
        setImportedBreadCrumb: (state, actions) => {
            state.importedBreadCrumb = {
                ...state.importedBreadCrumb,
                ...actions.payload
            };
        },
        setGlobalDialog: (state, action) => {
            state.globalDialog = action.payload;
        },
        closeGlobalDialog: (state) => {
            state.globalDialog = {
                ...state.globalDialog,
                open: false
            };
        },
        setActiveSection: (state, action) => {
            state.activeSection = action.payload;
        },
        setContents: (state, action) => {
            state.contents = action.payload;
        },
        setBackdropLoading: (state, action) => {
            state.backdropLoading = action.payload;
        }
    }
});

export const {
    openDrawer,
    closeDrawer,
    setPageLoading,
    setImportedBreadCrumb,
    setGlobalDialog,
    closeGlobalDialog,
    setActiveSection,
    setContents,
    setBackdropLoading
} = slice.actions;

export default slice.reducer;
